/**/
const ZERO = 1;
const DEFAULT_COLOR = '#E0E0E0';
const COLOR_LIST = ['#2297A0', '#94BFFF', '#3DDD9A', '#C39EFF', '#FFBE72'];

/**
 *
 */
export class CatchHistoryRecord {
  week: number;

  constructor(week: number, years: number[]) {
    this.week = week;
    years.forEach((y) => this.addValue(y));
  }

  addValue(year: number, value: number = ZERO) {
    this[String(year)] = value;
  }
}

/**
 *
 */
export function getColourByYear(year: number) {
  const thisYear = new Date().getFullYear();
  return COLOR_LIST[thisYear - year] || DEFAULT_COLOR;
}
